module.exports = __webpack_public_path__ + "static/media/ace_of_diamonds.dd4d7167.svg";